import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  USER_DETAILS_FEATURE_KEY,
  UserDetailsState,
  userDetailsAdapter,
} from './user-details.reducer';

// Lookup the 'UserDetails' feature state managed by NgRx
export const getUserDetailsState =
  createFeatureSelector<UserDetailsState>(USER_DETAILS_FEATURE_KEY);

const { selectAll, selectEntities } = userDetailsAdapter.getSelectors();

export const getProfileData = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state.profileData
);

export const getuserProfileOverview = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state.userProfileOverview
);

export const userPersonalInfo = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state.userPersonalInfo
);

export const getUserProfileImageData = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state.userProfileImageData
);

export const userEmailPreferencesStatusGet = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state.userEmailPreferencesStatus
);

export const clearImagestatus = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state.userImageStatus
);

export const getOranizationList = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state.organizationList
);

export const getSelectedOrg = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state.selectedOrg
);

export const getOrganizationName = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state.organizationName
);
